(function() {
    'use strict';
    angular
        .module('SMART2')
        .directive('pHeaderButton', ['$timeout', '$sce', '$rootScope', 'favoriteOps', pHeaderButtonFunc]);

    function pHeaderButtonFunc($timeout, $sce, $rootScope, favoriteOps) {
        return {
            scope: {
                config: '=',
                resetPanes: '&',
                toggleOverlay: '&',
                isLast: '@',
                remainingItems: '=',
                idx: '@',
                internalData: '=',
                externalData: '='
            },
            templateUrl: 'public/header/directives/headerButtonTemplate.html',
            replace: true,
            link: function($scope, iElm, iAttrs, controller) {
                $scope.toggle = toggle;
                $scope.onHowToRegisterClick = onHowToRegisterClick;
                $scope.marginRight = "";
                if ($scope.config.isUserProfile) {
                    $scope.config.icon = $sce.getTrustedResourceUrl($sce.trustAsResourceUrl($scope.config.icon));
                }
                var iconWidth = 54,
                    parentPaddingRight = 10,
                    siderWidth = 320; //, margin-right: 148px;;    
                $(document).click(function ($event) {
                    if (event) {
                        if ($(event.target).attr('id') == 'sidenav-overlay') {
                            $('.fixed-action-btn').css('display', 'block');
                        }
                    }
                });
                
                function onHowToRegisterClick(item) {
                    console.log(item, "onHowToRegisterClick BtnClick");
                    $rootScope.$broadcast('onHowToRegisterClick', {
                        item: item
                    });
                    //publicUtilities.downloadFile(item.fileId,'true');
                }
                
                function toggle(config) {
                    var visibleType = "";
                    if (config.name == "notification") {
                        visibleType = "announcement";
                        $rootScope.$broadcast('setEnable', {
                            visibleType: visibleType
                        });
                    } else if (config.name == "bookmark")
                    {
                        favoriteOps.fetchServerFavorites(null, null, false);
                        visibleType = "bookmark";
                        $rootScope.$broadcast('setEnableBookmark', {
                            visibleType: visibleType
                        });
                    }
                   
                    var newState = !config.showPane;
                    if ($scope.isLast) {
                        if ((typeof $scope.isLast).toLowerCase() === "string")
                            $scope.isLast = $scope.isLast.toLowerCase() === "true" ? true : false
                    }
                    $scope.resetPanes();
                    if (!$scope.isLast) {
                        if (newState) {
                            config.marginRight = { 'marginRight': (siderWidth - ((((Object.keys($scope.remainingItems).length - (Number($scope.idx)))) * iconWidth) + parentPaddingRight)) + "px" };
                            $('.fixed-action-btn').css('display', 'none');
                        } else {
                            config.marginRight = "";
                            $('.fixed-action-btn').css('display', 'block');
                        }
                    } else {
                        config.marginRight = "";
                        if (newState) {
                            $('.fixed-action-btn').css('display', 'none');
                        } else {
                            $('.fixed-action-btn').css('display', 'block');
                        }
                    }
                    config.active = newState;
                    $scope.toggleOverlay({ val: newState, name: config.name });
                    // NOTE: THIS TIMEOUT IS TO MAINTAIN SOME DELAY IN THE ANIMATION EFFECTS
                    $timeout(function() {
                        config.showPane = newState;
                    }, 100);
                };
            }
        };
    }
})(angular);
